import React, { useEffect, useRef, useState } from "react";
import "./styles.css";
import Button from "../button/button";
import DeleteTrashIcon from "../../icons/delete-trash-icon";
import PencilEditIcon from "../../icons/pencil-edit-icon";

const ActionsMenuComponent = ({
  isEditModal,
  setIsEditModal,
  editAccountNote,
  setEditAccountNote,
  handleDeleteComment,
  onEdit,
}) => {
  const [isInvoiceActionsMenuOpen, setIsInvoiceActionsMenuOpen] =
    useState(false);

  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsInvoiceActionsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleInvoiceActionOptionClick = () => {
    setIsInvoiceActionsMenuOpen((prev) => !prev);
  };

  const handleEditClick = () => {
    if (onEdit) {
      onEdit();
      setIsInvoiceActionsMenuOpen(false);
      return;
    }
    if (setEditAccountNote) {
      setEditAccountNote(editAccountNote);
    }
    if (setIsEditModal) {
      setIsEditModal(!isEditModal);
    }
    setIsInvoiceActionsMenuOpen(false);
  };

  return (
    <div ref={wrapperRef} style={{ position: "relative" }}>
      <div
        className="actions-menu-component-container"
        onClick={handleInvoiceActionOptionClick}
      >
        <svg
          width={16}
          height={16}
          viewBox="0 0 16 4"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="2" cy="2" r="2" />
          <circle cx="8" cy="2" r="2" />
          <circle cx="14" cy="2" r="2" />
        </svg>
      </div>
      {isInvoiceActionsMenuOpen && (
        <div
          className="invoice-page-dropdown-container"
          style={{ position: "absolute", right: "0px" }}
        >
          <Button
            variant="table-options-menu"
            subVariant="primary"
            icon={<PencilEditIcon />}
            className="button-width button-rounded"
            onClick={handleEditClick}
          >
            Edit
          </Button>
          {handleDeleteComment && (
            <Button
              variant="table-options-menu"
              subVariant="failure"
              icon={<DeleteTrashIcon />}
              className="button-width button-rounded"
              onClick={() => {
                handleDeleteComment();
                setIsInvoiceActionsMenuOpen(false);
              }}
            >
              Delete
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default ActionsMenuComponent;
